// extracted by mini-css-extract-plugin
module.exports = {"container":"PageHeaderText_container__FnA3q","texts":"PageHeaderText_texts__24jTt","title":"PageHeaderText_title__lUxmH","subtitle":"PageHeaderText_subtitle__15ieu"};